import { render } from "./ProductLabelYear.vue?vue&type=template&id=71bfc328"
import script from "./ProductLabelYear.vue?vue&type=script&lang=js"
export * from "./ProductLabelYear.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__